// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3gbDs","bigColWidth":"Table_bigColWidth__3_nmB","biggerColWidth":"Table_biggerColWidth__3lHBq","row":"Table_row__3YKuD","col":"Table_col__Oz5zB"};